let parseNonString = (item, alt) => {
  item = typeof item !== "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    item = alt;
  }

  if (item == null) {
    item = alt;
  }

  return item;
};

let initTokenExpiration = () => {
  var time = null;
  if (localStorage.getItem("tokenExpiration")) {
    try {
      time = new Date(JSON.parse(localStorage.getItem("tokenExpiration")));
    } catch {}
  } else if (localStorage.getItem("expirationTime")) {
    try {
      time = new Date(localStorage.getItem("expirationTime"));
    } catch {}
  }
  return time;
};

export default {
  authenticated: parseNonString(localStorage.getItem("isAuthenticated"), false),
  hasLoadedPermissions: parseNonString(
    localStorage.getItem("hasLoadedPermissions"),
    false
  ),
  user: parseNonString(localStorage.getItem("userId"), null),
  userData: parseNonString(localStorage.getItem("userData"), null),
  userName: parseNonString(localStorage.getItem("userName"), null),
  userEmail: parseNonString(localStorage.getItem("userEmail"), null),
  userDateOfBirth: parseNonString(
    localStorage.getItem("userDateOfBirth"),
    null
  ),
  token:
    localStorage.getItem("accessToken") == null
      ? ""
      : JSON.parse(localStorage.getItem("accessToken")),
  tokenExpiration: initTokenExpiration(),
  setup: parseNonString(localStorage.getItem("setup"), false),
  isSuperAdmin: parseNonString(localStorage.getItem("isSuperAdmin"), false),
  isTreasurer: parseNonString(localStorage.getItem("isTreasurer"), false),
  isTreasurerAddClient: parseNonString(
    localStorage.getItem("isTreasurerAddClient"),
    false
  ),
  treasurerAccounts: parseNonString(
    localStorage.getItem("treasurerAccounts"),
    null
  ),
  consultantFundraiserAccounts: parseNonString(
    localStorage.getItem("consultantFundraiserAccounts"),
    null
  ),
  isLoginFromOldUI: parseNonString(
    localStorage.getItem("isLoginFromOldUI"),
    false
  ),
  redirectUrl: parseNonString(localStorage.getItem("redirectUrl"), null),

  // pauseAuth: parseNonString(localStorage.getItem("pauseAuth"), false),
  // authError:
  // 	localStorage.getItem("authError") == null
  // 		? ""
  // 		: localStorage.getItem("authError"),
  // authErrorTimer: localStorage.getItem("authErrorTimer")
  // 	? new Date(JSON.parse(localStorage.getItem("authErrorTimer")))
  // 	: null,
  // context: parseNonString(localStorage.getItem("context"), null),
  // loginPopup: parseNonString("loginPopup", false), //Shouldn't this be just 'false'?
  // returnUrl:
  // 	localStorage.getItem("returnUrl") == null
  // 		? ""
  // 		: localStorage.getItem("returnUrl"),
  // refreshTimer: localStorage.getItem("refreshTimer")
  // 	? new Date(JSON.parse(localStorage.getItem("refreshTimer")))
  // 	: null,
  // log: initLog(),
  // tenantId:
  // 	localStorage.getItem("tenantId") == null
  // 		? ""
  // 		: localStorage.getItem("tenantId"),
};
